/* 
    add support to closest() 
    https://developer.mozilla.org/en-US/docs/Web/API/Element/closest
*/

if (!Element.prototype.matches) {
   Element.prototype.matches =
      Element.prototype.msMatchesSelector ||
      Element.prototype.webkitMatchesSelector;
}

if (!Element.prototype.closest) {
   Element.prototype.closest = function(s) {
      var el = this;

      do {
         if (el.matches(s)) return el;
         el = el.parentElement || el.parentNode;
      } while (el !== null && el.nodeType === 1);
      return null;
   };
}

// Toggle Target using Anchor

document.addEventListener("click", function(e) {
   if (e.target.closest(".toggle-anchor")) {
      toggle = e.target.closest(".toggle-anchor");
      targetID = toggle.href.match(/#(.+)/);
      target = document.getElementById(targetID[1]);

      target.classList.toggle("toggle-hidden");
      toggle.classList.toggle("toggle-active");

      e.preventDefault();
   }
});

// Toggle Next Element

document.addEventListener("click", toggleNextElement);

function toggleNextElement(e) {
   // close all if clicked out of toggle and target area
   if (
      !e.target.closest(".toggle-next") &&
      !e.target.closest(".toggle-next + *")
   )
      toggleCloseAll();

   if (e.target.closest(".toggle-next")) {
      e.preventDefault();

      var toggle = e.target.closest(".toggle-next");
      var target = toggle.nextElementSibling;

      if (target.classList.contains("toggle-hidden")) toggleCloseAll();

      target.classList.toggle("toggle-hidden");
      toggle.classList.toggle("toggle-active");
   }
}

function toggleCloseAll() {
   dropdowns = document.querySelectorAll(".toggle-dropdown");
   dropdowns.forEach(function(menus) {
	  menus.classList.add("toggle-hidden");
	  menus.previousElementSibling.classList.remove('toggle-active');
   });
}

/* Delete after refactor */

document.addEventListener("click", function(e) {
   var target = e.target;

   /**
    * show or hide nearby nodes
    * this works for container modules not for far away branches
    */

   if (target.closest(".toggle-trigger")) {
      //get intended trigger not captured inner el

      var toggleTrigger = target.closest(".toggle-trigger");

      var toggleParent = target.closest(".toggle-has-child");

      var toggleTarget = toggleParent.querySelector(".toggle-target");

      if (toggleTarget) {
         toggleTarget.classList.toggle("toggle-on");
         toggleTarget.classList.toggle("toggle-off");

         toggleTrigger.classList.toggle("toggle-on");
         toggleTrigger.classList.toggle("toggle-off");
      }
   }
});
